export function escapeHtml(s: string): string {
  const d = document.createElement("div");
  d.textContent = s;
  return d.innerHTML;
}

/** URL hash for a group's feed / correspondence-details page. Shared so
 *  app.ts (nav/routing) and groups.ts (sidebar links) build the same string
 *  instead of one of them inlining it. */
export function feedHash(groupId: string): string {
  return `#g/${groupId}`;
}
export function detailsHash(groupId: string): string {
  return `#g/${groupId}/settings`;
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric",
  });
}

// Window-injected runtime config (set by the server's index route).
declare global {
  interface Window {
    SNAIL_BOT_USERNAME: string;
    SNAIL_API_ID: string;
    SNAIL_API_HASH: string;
  }
}

export function apiId(): number {
  return parseInt(window.SNAIL_API_ID || "0", 10);
}
export function apiHash(): string {
  return window.SNAIL_API_HASH || "";
}
export function botUsername(): string {
  return window.SNAIL_BOT_USERNAME || "snail_bot";
}

/** Which group a route applies to: an explicit id in the hash wins; otherwise
 *  keep whatever correspondence is already open (so #about doesn't clobber the
 *  selection and repoint the Settings link at the default group); otherwise
 *  the default (first) group. */
export function resolveActiveGroup(
  hashGroupId: string | null,
  current: string | null,
  fallback: string | null
): string | null {
  return hashGroupId ?? current ?? fallback;
}

/** Passive, auto-dismissing notification (used for "Connected to Snail ✓"). */
export function toast(message: string): void {
  const el = document.createElement("div");
  el.className = "toast";
  el.textContent = message;
  document.body.appendChild(el);
  requestAnimationFrame(() => el.classList.add("show"));
  setTimeout(() => {
    el.classList.remove("show");
    setTimeout(() => el.remove(), 300);
  }, 2600);
}
